export const colors = {
  primary: {
    main: "#3B82F6",
    light: "#93C5FD",
    dark: "#1D4ED8",
    contrast: "#FFFFFF",
  },
  secondary: {
    main: "#10B981",
    light: "#6EE7B7",
    dark: "#047857",
    contrast: "#FFFFFF",
  },
  error: {
    main: "#EF4444",
    light: "#FCA5A5",
    dark: "#B91C1C",
    contrast: "#FFFFFF",
  },
  warning: {
    main: "#F59E0B",
    light: "#FCD34D",
    dark: "#B45309",
    contrast: "#FFFFFF",
  },
  success: {
    main: "#10B981",
    light: "#6EE7B7",
    dark: "#047857",
    contrast: "#FFFFFF",
  },
  info: {
    main: "#3B82F6",
    light: "#93C5FD",
    dark: "#1D4ED8",
    contrast: "#FFFFFF",
  },
  gradient: {
    primary: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)",
    secondary: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
    dark: "linear-gradient(135deg, #1F2937 0%, #111827 100%)",
  },
  grey: {
    50: "#F9FAFB",
    100: "#F3F4F6",
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#374151",
    800: "#1F2937",
    900: "#111827",
  },
  background: {
    default: "#F9FAFB",
    paper: "#FFFFFF",
    dark: "#1F2937",
  },
  text: {
    primary: "#111827",
    secondary: "#4B5563",
    disabled: "#9CA3AF",
    hint: "#6B7280",
  },
  border: {
    light: "#E5E7EB",
    main: "#D1D5DB",
    dark: "#9CA3AF",
  },
  divider: "#E5E7EB",
  action: {
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "rgba(0, 0, 0, 0.08)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
};
